import {AfterViewInit, Directive, ElementRef, HostBinding, Input} from '@angular/core';
import {WindowService} from '@app/core/shared/domain/window.service';

@Directive({ selector: 'img' })
export class LazyLoadDirective implements AfterViewInit {
    @HostBinding("attr.src") srcAttr: string | undefined ;
    @Input() src: string | undefined;

    constructor(private el: ElementRef, private windowService: WindowService) {}

    ngAfterViewInit() {
        this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage();
    }

    private canLazyLoad() {
        return this.windowService.getWindow() && "IntersectionObserver" in window;
    }

    private lazyLoadImage() {
        const obs = new IntersectionObserver(entries => {
            entries.forEach(({ isIntersecting }) => {
                if (isIntersecting) {
                    this.loadImage();
                    obs.unobserve(this.el.nativeElement);
                }
            });
        });
        obs.observe(this.el.nativeElement);
    }

    private loadImage() {
        this.srcAttr = this.src;
    }
}
